export default __webpack_public_path__ + "static/media/register.0f447db5.svg";